import { Component, ViewChildren, QueryList, OnInit } from '@angular/core';
import { Platform, IonRouterOutlet, AlertController, ModalController, ToastController, NavController, } from '@ionic/angular';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { TranslateService } from '@ngx-translate/core';

import { Router } from '@angular/router';
import { Events } from './provider/events.service';
import { ConfigService } from './provider/config.service';
import { ApiService } from './provider/api.service';
import { AuthService } from './services/auth.service';
import { endpoints } from './constant/endpoints';
import { environment } from 'src/environments/environment';


export interface HSLColor {
  h: number;
  s: number;
  l: number;
  opacity?: number;
}

export interface HSLAdjustment {
  fixed?: number;
  percent?: number;
  adjust?: number;
  h?: number;
  s?: number;
  l?: number;
}

export interface HSLModifyOptions {
  h?: HSLAdjustment;
  s?: HSLAdjustment;
  l?: HSLAdjustment;
  opacity?: number;
}


@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit{
    @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;
    settings: any = {}; backButton = true;
    connectedToInternet: boolean = true;
    lastTimeBackPress = 0;
    timePeriodToExit = 2000;
    splash = false;
    serverVersion = 0;
    currency: any = {};
    splittedVersion;
    androidURL = 'https://play.google.com/store/apps/details?id=com.go.abieta&pli=1';
    iosURL = "https://apps.apple.com/us/app/abieta/id1600484121";
    appLogo = 'assets/dummy.png';
  shadowConfigs = {
    // Core shadows - More punchy and defined
    'm': [
        { x: 0, y: 1, blur: 2, opacity: 0.12 },
        { x: 1, y: 3, blur: 6, spread: -1, opacity: 0.15 },
        { x: 1, y: 6, blur: 12, spread: -2, opacity: 0.12 }
    ],
    'l': [
        { x: 0, y: 1, blur: 2, opacity: 0.10 },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.12 }
    ],
    'h': [
        { x: 0, y: 3, blur: 6, spread: -1, opacity: 0.15 },
        { x: 1, y: 6, blur: 12, spread: -2, opacity: 0.20 },
        { x: 1, y: 12, blur: 24, spread: -3, opacity: 0.20 }
    ],
    'h2': [ // Dramatic high shadow
        { x: 0, y: 4, blur: 8, spread: -1, opacity: 0.18 },
        { x: 1, y: 8, blur: 16, spread: -2, opacity: 0.15 },
        { x: 1, y: 16, blur: 32, spread: -4, opacity: 0.12 }
    ],

    // Elevation shadows - Crisper and more defined
    'elevation-low': [
        { x: 0, y: 1, blur: 2, opacity: 0.15 },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.12 }
    ],
    'elevation-medium': [
        { x: 0, y: 2, blur: 4, opacity: 0.15 },
        { x: 1, y: 4, blur: 8, spread: -1, opacity: 0.18 },
        { x: 1, y: 8, blur: 16, spread: -2, opacity: 0.15 }
    ],
    'elevation-high': [
        { x: 0, y: 4, blur: 8, spread: -1, opacity: 0.20 },
        { x: 1, y: 8, blur: 16, spread: -2, opacity: 0.22 },
        { x: 1, y: 16, blur: 32, spread: -4, opacity: 0.18 }
    ],

    // Diffuse shadows - More noticeable ambient effect
    'diffuse': [
        { x: 0, y: 0, blur: 4, spread: 0, opacity: 0.08 },
        { x: 1, y: 2, blur: 8, spread: -1, opacity: 0.10 },
        { x: 1, y: 4, blur: 16, spread: -2, opacity: 0.12 }
    ],
    'color-s': [ // Enhanced colored special diffuse
        { x: 0, y: 0, blur: 8, spread: 2, opacity: 0.08 },
        { x: 1, y: 4, blur: 16, spread: -1, opacity: 0.12 },
        { x: 1, y: 8, blur: 24, spread: -2, opacity: 0.15 }
    ],

    // Inner shadows - Stronger depth effect
    'l1': [
        { x: 0, y: 1, blur: 2, opacity: 0.15, inset: true },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.20, inset: true }
    ],
    'l2': [
        { x: 0, y: 2, blur: 4, opacity: 0.20, inset: true },
        { x: 1, y: 4, blur: 8, spread: 1, opacity: 0.25, inset: true }
    ],
    'l3': [
        { x: 0, y: 1, blur: 12, spread: 1, opacity: 0.05, inset: true },
        { x: 1, y: 2, blur: 20, spread: -4, opacity: 0.10, inset: true }
    ],
    'inner': [
        { x: 1, y: -1, blur: 2,spread: 2, opacity: 0.1, inset: true },
        { x: 1, y: 1, blur: 4, spread: 1, opacity: 0.2, inset: true }
    ],
    'inner2': [
        { x: 0, y: 0, blur: 1,spread: 1, opacity: 0.1, inset: true },
        { x: 0, y: 0, blur: 0, spread: 1, opacity: 0.3, inset: true }
    ],    
        'inner3': [
        { x: 0, y: 0, blur: 1,spread: 0, opacity: 0.1, inset: true },
        { x: 0, y: 0, blur: 0, spread: 0, opacity: 0.1, inset: true }
    ],   
    'l4': [
        { x: 0, y: 4, blur: 8, opacity: 0.25, inset: true },
        { x: 1, y: 8, blur: 16, spread: 2, opacity: 0.30, inset: true }
    ],

    // Card shadows - Sharper and more defined
    'card': [
        { x: 0, y: 1, blur: 2, spread: 0, opacity: 0.12 },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.15 },
        { x: 1, y: 4, blur: 8, spread: -2, opacity: 0.12 }
    ],
    'm-c': [ // Colored medium with better contrast
        { x: 0, y: 2, blur: 4, spread: -1, opacity: 0.15 },
        { x: 1, y: 4, blur: 8, spread: -2, opacity: 0.18 },
        { x: 1, y: 8, blur: 16, spread: -3, opacity: 0.15 }
    ],

    // Directional shadows - More pronounced
    'side': [
        { x: 1, y: 1, blur: 4, spread: -1, opacity: 0.12 },
        { x: 1.5, y: 1.5, blur: 8, spread: -2, opacity: 0.15 }
    ],
    'm-side': [
        { x: 3, y: 5, blur: 10, spread: -1, opacity: 0.05 },
        { x: 5, y: 3, blur: 10, spread: -2, opacity: 0.1 }
    ],
    'side-anim': [
        { x: 3, y: 5, blur: 10, spread: -1, opacity: 0.05 },
        { x: 5, y: 3, blur: 10, spread: -2, opacity: 0.1 }
    ],
    'side-anim-end': [
        { x: 9, y: 15, blur: 10, spread: -1, opacity: 0.15 },
        { x: 18, y: 30, blur: 10, spread: -2, opacity: 0.1 }
    ],
    'btn-anim': [
        { x: 1.5, y: 2.5, blur: 7, spread: -0.5, opacity: 0.05 },
        { x: 2.5, y: 1.5, blur: 7, spread: -1, opacity: 0.1 }
    ],
    'btn-anim-end': [
        { x: 4.5, y: 7.5, blur: 6, spread: -0.5, opacity: 0.2 },
        { x: 9, y: 15, blur: 6, spread: -1, opacity: 0.1 }
    ],
    'option-anim': [
        { x: 1, y: 2, blur: 5, spread: -0.5, opacity: 0.05 },
        { x: 2, y: 1, blur: 5, spread: -1, opacity: 0.1 }
    ],
    'option-anim-end': [
        { x: 3, y: 2, blur: 6, spread: -0.5, opacity: 0.2 },
        { x: 9, y: 1, blur: 6, spread: -1, opacity: 0.1 }
    ],
    // 'side-anim': [
    //     { x: 0, y: -0.5, blur: 0, spread: 0, opacity: 0.1 },
    //     { x: 0.5, y: 0, blur: 0, spread: 0, opacity: 0.2 }
    // ],
    // 'side-anim-end': [
    //     { x: -0.5, y: 0, blur: 0, spread: 0, opacity: 0.1 },
    //     { x: 0, y: 0.5, blur: 0, spread: 0, opacity: 0.2 }
    // ],

    // Special effects - Enhanced visibility
    'm-anim': [ // Animation-friendly with better presence
        { x: 0, y: 2, blur: 4, spread: -1, opacity: 0.12 },
        { x: 1, y: 4, blur: 8, spread: -2, opacity: 0.15 },
        { x: 1, y: 8, blur: 16, spread: -3, opacity: 0.12 }
    ],
    'm-small': [ // Subtle but visible
        { x: 0, y: 1, blur: 2, opacity: 0.10 },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.12 },
        { x: 1, y: 3, blur: 6, spread: -1, opacity: 0.10 }
    ],
    'md': [ // Dense medium with better definition
        { x: 0, y: 1, blur: 2, opacity: 0.15 },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.20 }
    ],
    'mid': [ // Dense medium with better definition
        { x: 0, y: 1, blur: 2, opacity: 0.15 },
        { x: 1, y: 2, blur: 4, spread: -1, opacity: 0.20 }
    ]
};
    colorprimary: any;
colorsecondary: any;
colortertiary: any;
p2: any;
s2: any;
t2: any;
p3: any;
s3: any;
t3: any;
shadowlight: any;
shadowdark: any;
shadowcolorlight: any;
shadowcolordark: any;
bglight: any;
bgdark: any;
highlight: any;
highdark: any;
diffuselight: any;
diffusedark: any;
diffuselightselected: any;
diffusedarkselected: any;
colorlight: any;
colordark: any;
colorback: any;
colorbackdark: any;
greenmacro: any;
redmacro: any;
yellowmacro: any;
shadowhighlight: any;
shadowhighdark: any;
lowNutrition: any;
highNutrition:any;
avgNutrition:any;
carbcolor:any;
caloriecolor:any;
protcolor:any;
fatcolor:any;

	protcolorlight: string;
	fatcolorlight: string;
	carbcolorlight: string;
	caloriecolorlight: string;
	weekMenuData: any[];
	customer: any;
	daysafter: number;
    slideback: string;
    colortertiarymain: string;
    colorsecondarymain: string;
    colorprimarymain: string;
    // colors = {
    //     primary_container: '#d2a787',
    //     secondary_container: '#DFA878',
    //     tertiary_container: '#6C3428',
    //     on_primary_container: '#d2a787',
    //     on_secondary_container: '#DFA878',
    //     on_tertiary_container: '#6C3428'
    // };
    colors = {
        primary: '#35858b',
        secondary: '#4fbdba',
        tertiary: '#082227',
        on_primary: '#35858b',
        on_secondary: '#4fbdba',
        on_tertiary: '#082227'
    };
    white: string;
    black: string;
    light: any;
    dark: any;
    lightgrey: string;
    darkgrey: string;
    darker: string;
    grey: string;
    greyhalf: string;
    greymore: string;
    greyless: string;
    darklightgrey: string;
    darkdarkgrey: string;
    darkdarker: string;
    darkgreyhalf: string;
    darkgreymore: string;
    darkgreyless: string;
    banners: string[] = []; // Store multiple banners
    currentBannerIndex = 0; // To track the current banner index
    bannerSwitchInterval: any; 
    invertPrime: string;
    invertSecond: string;
    invertTri: string;
    dtextprimary: string;
    dtextsecond: string;
    dtexttri: string;
    colorprimarydeeper: string;
    colorsecondarydeeper: string;
    colortertiarydeeper: string;
    colortertiarylighter: string;
    colorprimarylighter: string;
    colorsecondarylighter: string;
    diffusecolorselected: string;
    diffusecolor: string;
    darkermain = {
        h: 0, // Hue in degrees (0 to 360)
        s: 5, // Saturation in percentage (0 to 100)
        l: 5, // Lightness in percentage (0 to 100)
      };
      lightermain = {
        h: 0, // Hue in degrees (0 to 360)
        s: 0, // Saturation in percentage (0 to 100)
        l: 95, // Lightness in percentage (0 to 100)
      };
    p4: string;
    s4: string;
    t4: string;

    constructor(
        private router: Router,
        private platform: Platform,
        private events: Events,
        private network: Network,
        private appVersion: AppVersion,
        private inAppBrowser: InAppBrowser,
        private toastCtrl: ToastController,
        private modalCtrl: ModalController,
        private alertCtrl: AlertController,
        private navCtrl: NavController,
        private translate: TranslateService,
        private screenOrientation: ScreenOrientation,
        private authService: AuthService,
        private configService: ConfigService,
        private apiService: ApiService,
    ) {
 
    


    
    }
    async ngOnInit() {
    
        this.getBackgroundImage();
        await this.loadBackgroundData()
      }
      async ionViewWillEnter() {
        await this.loadBackgroundData()

      }
      async loadBackgroundData() {
        setTimeout(() => {
          this.splash = false;
          this.configService.getAppSettings()
              .then((settingData: any) => {
                  this.settings = JSON.parse(settingData);
                  //alert(this.settings.appLanguage);
                  this.translate.setDefaultLang(this.settings.appLanguage);
                  this.translate.use(this.settings.appLanguage);
                  this.appUser(this.settings.currentUser);
                  if (this.platform.is("capacitor")) {
                      this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
                      this.checkNetworkConnection();
                      this.backButtonEvent();
                      
                    //   document.documentElement.style.setProperty('.ion-color-primary', '--ion-color-base: #36454f!important');
                  }
                //   document.body.classList.toggle('dark', this.settings.appDarkMode);
              }
              );
              this.apiService
              .get(endpoints.configuration)
              .subscribe(response => {
                  if (response.success) {
                      console.log(response,'config');
                      const htmlEl = document.querySelector('html');
                      if (response.data.configurations.theme) {
                        //   this.colors = { ...this.colors, ...response.data.configurations.theme }; // Merge and overwrite existing values

                          this.colors.primary =
                          response.data.configurations.theme.primary;
                        this.colors.secondary =
                          response.data.configurations.theme.secondary;
                        this.colors.tertiary =
                          response.data.configurations.theme.tertiary;
                        this.colors.on_primary =
                          response.data.configurations.theme.on_primary;
                        this.colors.on_secondary =
                          response.data.configurations.theme.on_secondary;
                        this.colors.on_tertiary =
                          response.data.configurations.theme.on_tertiary;
                
                      }
                      console.log(this.colors)

                  
               
              this.p2 = this.finalHSL(this.hexToHsl(this.colors.primary));
      this.s2 = this.finalHSL(this.hexToHsl(this.colors.secondary));
      this.t2 = this.finalHSL(this.hexToHsl(this.colors.tertiary));

      this.theColorUpdate(this.colors.primary,this.colors.secondary,this.colors.tertiary);
            
                    
                      console.log(response);
                  //console.log(response);
                  this.events.publish('app:branches', { branches: response.data.branches, time: new Date() });
                  this.events.publish('app:organization', { organization: response.data.organization, time: new Date() });
                  this.configService.setStorage('appPayload', response.data);
                  if (this.platform.is("capacitor")) {
                      this.checkLatestVersion(response.data.organization.force_update);
                  }
                  }
              }
              );
    
      this.events.subscribe('user:login', (data: any) => {
        const customer = this.authService.getAuthUser();
        console.log(customer);
        if (data.user == null) {
            this.configService.getAppSettings()
                .then(async (settingData: any) => {
                    this.settings = JSON.parse(settingData);
                    console.log(this.settings);
                    this.settings.currentUser = null;
                    this.configService.setStorage('appSettings', this.settings);
                    try {
                        const element = await this.modalCtrl.getTop();
                        if (element) {
                            element.dismiss();
                        }
                    } catch (error) {
                        console.log(error);
                    }
                    console.log('MD');
                    this.authService.setAuthUser(null);
                    this.authService.logOutUser();
                    /*this.configService.setStorage('bookProductData', null);
                    this.configService.setStorage('bookSalonData', null);*/
                    this.navCtrl.navigateRoot([environment.LOGIN_PAGE]);
                }
                );
        }
    });
    this.events.subscribe('app:update', (data: any) => {
        const customer = this.authService.getAuthUser();
        console.log(customer);
        if (data.user == null) {
            this.configService.getAppSettings()
                .then(async (settingData: any) => {
                    this.settings = JSON.parse(settingData);
                    console.log(this.settings);
                    this.settings.currentUser = null;
                    this.configService.setStorage('appSettings', this.settings);
                    this.authService.setAuthUser(null);
                    this.authService.logOutUser();
                    this.navCtrl.navigateRoot(['/force-update']);
                }
                );
        }
    });
    this.events.subscribe('language:change', (data: any) => {
            console.log(data)
            setTimeout(() => {
                window.location.reload();
            }, 500);
        }
    );
    this.events.subscribe("DarkMode:change", (data: any) => {
        console.log(data);
        setTimeout(() => {
          const htmlEl = document.querySelector("html");
  
          console.log(data);
  
          // if (data) {
          //   htmlEl.style.setProperty("--ion-color-primary", this.p2);
          //   htmlEl.style.setProperty("--ion-color-secondary", this.s2);
          //   htmlEl.style.setProperty("--ion-color-tertiary", this.t2);
  
          //   htmlEl.style.setProperty("--p2", this.colorprimarymain);
          //   htmlEl.style.setProperty("--s2", this.colorsecondarymain);
          //   htmlEl.style.setProperty("--t2", this.colortertiarymain);
  
          //   htmlEl.style.setProperty("--tprimary", this.invertPrime);
          //   htmlEl.style.setProperty("--tsecondary", this.invertSecond);
          //   htmlEl.style.setProperty("--ttertiary", this.invertTri);
  
          //   htmlEl.style.setProperty("--ion-text-primary", this.dtextprimary);
          //   htmlEl.style.setProperty("--ion-text-secondary", this.dtextsecond);
          //   htmlEl.style.setProperty("--ion-text-tertiary", this.dtexttri);
  
          //   htmlEl.style.setProperty("--shadow-light", this.shadowlight); //grays only for base shadows
          //   htmlEl.style.setProperty(
          //     "--shadow-color-light",
          //     this.shadowcolorlight
          //   ); //colored shadows will be based on primary color
          //   htmlEl.style.setProperty("--bg-light", this.bgdark); // background color will be based on primary color
          //   htmlEl.style.setProperty("--bg-dark", this.bglight);
          //   htmlEl.style.setProperty("--highlight", this.highdark);
          //   htmlEl.style.setProperty("--highdark", this.highlight); //highlights colors - based on secondary color
          //   htmlEl.style.setProperty("--shadowhighdark", this.shadowhighlight);
          //   htmlEl.style.setProperty("--shadowhighlight", this.shadowhighdark); //based on the highlight color
          //   htmlEl.style.setProperty("--diffuse-light", this.diffusedark);
          //   htmlEl.style.setProperty("--diffuse-dark", this.diffuselight);
          //   htmlEl.style.setProperty(
          //     "--diffuse-light-selected",
          //     this.diffusedarkselected
          //   );
          //   htmlEl.style.setProperty(
          //     "--diffuse-dark-selected",
          //     this.diffuselightselected
          //   );
          //   htmlEl.style.setProperty("--ion-light", this.colordark);
          //   htmlEl.style.setProperty("--ion-dark", this.colorlight);
          //   htmlEl.style.setProperty("--colorback", this.colorbackdark);
          //   htmlEl.style.setProperty("--ion-color-light", this.black);
          //   htmlEl.style.setProperty("--ion-color-dark", this.white);
          //   htmlEl.style.setProperty("--light", this.colordark);
          //   htmlEl.style.setProperty("--dark", this.colorlight);
          //   htmlEl.style.setProperty(
          //     "--diffuse-selected",
          //     this.diffusedarkselected
          //   );
          //   htmlEl.style.setProperty("--diffuse", this.diffusedark);
          //   htmlEl.style.setProperty("--diffuse-color", this.diffusecolor);
          //   htmlEl.style.setProperty(
          //     "--diffuse-color-selected",
          //     this.diffusecolorselected
          //   );
  
          //   htmlEl.style.setProperty("--lightgrey", this.darklightgrey);
          //   htmlEl.style.setProperty("--darkgrey", this.darkdarkgrey);
          //   htmlEl.style.setProperty("--darker", this.darkdarker);
          //   htmlEl.style.setProperty("--grey", this.darkgrey);
          //   htmlEl.style.setProperty("--greyhalf", this.darkgreyhalf);
          //   htmlEl.style.setProperty("--greymore", this.darkgreymore);
          //   htmlEl.style.setProperty("--greyless", this.darkgreyless);
          // } else {
          //   htmlEl.style.setProperty("--p2", this.p2);
          //   htmlEl.style.setProperty("--s2", this.s2);
          //   htmlEl.style.setProperty("--t2", this.t2);
  
          //   htmlEl.style.setProperty(
          //     "--ion-color-primary",
          //     this.colorprimarymain
          //   );
          //   htmlEl.style.setProperty(
          //     "--ion-color-secondary",
          //     this.colorsecondarymain
          //   );
          //   htmlEl.style.setProperty(
          //     "--ion-color-tertiary",
          //     this.colortertiarymain
          //   );
  
          //   htmlEl.style.setProperty("--tprimary", this.invertPrime);
          //   htmlEl.style.setProperty("--tsecondary", this.invertSecond);
          //   htmlEl.style.setProperty("--ttertiary", this.invertTri);
  
          //   htmlEl.style.setProperty("--ion-text-primary", this.dtextprimary);
          //   htmlEl.style.setProperty("--ion-text-secondary", this.dtextsecond);
          //   htmlEl.style.setProperty("--ion-text-tertiary", this.dtexttri);
  
          //   htmlEl.style.setProperty("--shadow-light", this.shadowdark); //grays only for base shadows
          //   htmlEl.style.setProperty(
          //     "--shadow-color-light",
          //     this.shadowcolordark
          //   ); //colored shadows will be based on primary color
          //   htmlEl.style.setProperty("--bg-light", this.bglight); // background color will be based on primary color
          //   htmlEl.style.setProperty("--bg-dark", this.bgdark);
          //   htmlEl.style.setProperty("--highlight", this.highlight);
          //   htmlEl.style.setProperty("--highdark", this.highdark); //highlights colors - based on secondary color
          //   htmlEl.style.setProperty("--shadowhighdark", this.shadowhighdark);
          //   htmlEl.style.setProperty("--shadowhighlight", this.shadowhighlight); //based on the highlight color
          //   htmlEl.style.setProperty("--diffuse-light", this.diffuselight);
          //   htmlEl.style.setProperty("--diffuse-dark", this.diffusedark);
          //   htmlEl.style.setProperty(
          //     "--diffuse-light-selected",
          //     this.diffuselightselected
          //   );
          //   htmlEl.style.setProperty(
          //     "--diffuse-dark-selected",
          //     this.diffusedarkselected
          //   );
          //   htmlEl.style.setProperty("--ion-light", this.colorlight);
          //   htmlEl.style.setProperty("--ion-dark", this.colordark);
          //   htmlEl.style.setProperty("--colorback", this.colorback);
          //   htmlEl.style.setProperty("--diffuse-color", this.diffusecolor);
          //   htmlEl.style.setProperty(
          //     "--diffuse-color-selected",
          //     this.diffusecolorselected
          //   );
  
          //   htmlEl.style.setProperty("--ion-color-light", this.white); //for regular
          //   // htmlEl.style.setProperty('--ion-color-light',this.black); //for pointy nail spa
          //   htmlEl.style.setProperty("--ion-color-dark", this.black);
          //   htmlEl.style.setProperty("--light", this.colorlight);
          //   htmlEl.style.setProperty("--dark", this.colordark);
          //   htmlEl.style.setProperty(
          //     "--diffuse-selected",
          //     this.diffusedarkselected
          //   );
          //   htmlEl.style.setProperty("--diffuse", this.diffusedark);
  
          //   htmlEl.style.setProperty("--lightgrey", this.lightgrey);
          //   htmlEl.style.setProperty("--darkgrey", this.darkgrey);
          //   htmlEl.style.setProperty("--darker", this.darker);
          //   htmlEl.style.setProperty("--grey", this.grey);
          //   htmlEl.style.setProperty("--greyhalf", this.greyhalf);
          //   htmlEl.style.setProperty("--greymore", this.greymore);
          //   htmlEl.style.setProperty("--greyless", this.greyless);
          // }
  
        //   if (data) {
        //       this.colorprimary = this.hexToHsl(this.colors.primary);
        //       this.colorsecondary = this.hexToHsl(this.colors.secondary);
        //       this.colortertiary = this.hexToHsl(this.colors.tertiary);
    
        //       this.colorprimarymain = this.hslMake(
        //         this.hexToHsl(this.colors.primary)
        //       );
        //       this.colorsecondarymain = this.hslMake(
        //         this.hexToHsl(this.colors.secondary)
        //       );
        //       this.colortertiarymain = this.hslMake(
        //         this.hexToHsl(this.colors.tertiary)
        //       );
      
    
        //       this.white = "#000";
        //       this.black = "#fff";
        //       this.light = "#000";
        //       this.dark = "#fff";
    
        //       this.lightgrey = "#484848";
        //       this.darkgrey = "#d2d2d2";
        //       this.darker = "#e3e3e3";
        //       this.grey = "#2c2c2c";
        //       this.greyhalf = "#e1e1e150";
        //       this.greymore = "#d4d4d475";
        //       this.greyless = "#9e9e9e25";
        //     } else {
    
        //       this.colorprimary = this.hexToHsl(this.colors.on_primary);
        //       this.colorsecondary = this.hexToHsl(this.colors.on_secondary);
        //       this.colortertiary = this.hexToHsl(this.colors.on_tertiary);
    
        //       this.colorprimarymain = this.hslMake(
        //         this.hexToHsl(this.colors.on_primary)
        //       );
        //       this.colorsecondarymain = this.hslMake(
        //         this.hexToHsl(this.colors.on_secondary)
        //       );
        //       this.colortertiarymain = this.hslMake(
        //         this.hexToHsl(this.colors.on_tertiary)
        //       );
      
    
        //       this.white = "#fff";
        //       this.black = "#000";
        //       this.light = '#fff';
        //       this.dark = '#000';
    
        //       this.lightgrey = "#e7e7e7";
        //       this.darkgrey = "#5a5a5a";
        //       this.darker = "#2c2c2c";
        //       this.grey = "#c1c1c1";
        //       this.greyhalf = "#c1c1c150";
        //       this.greymore = "#c1c1c175";
        //       this.greyless = "#c1c1c125";
        //     }
        //     //alternate colors for primary, secondary and tertiary
    
        //     // below colors only for shadows - will not work as regular variables
        //     this.shadowlight = this.hslShadowDark(this.colortertiary);
        //     this.shadowdark = this.hslShadowLight(this.colortertiary);
        //     this.shadowcolorlight = this.hslMakerShadow(
        //       this.hslShadowColorLight(this.colorprimary)
        //     );
        //     this.shadowcolordark = this.hslMakerShadow(
        //       this.hslShadowColorDark(this.colorprimary)
        //     );
    
        //     // below colors for background
        //     this.bglight = this.bgLight(this.colorprimary);
        //     this.bgdark = this.bgDark(this.colorprimary);
    
        // this.colorprimarylighter = this.lighter(this.colorprimary);
        //       this.colorsecondarylighter = this.lighter(this.colorsecondary);
        //       this.colortertiarylighter = this.lighter(this.colortertiary);
  
        // this.colorprimarydeeper = this.deeper(this.colorprimary);
        //       this.colorsecondarydeeper = this.deeper(this.colorsecondary);
        //       this.colortertiarydeeper = this.deeper(this.colortertiary);
        //     // below colors for highlights
        //     this.highlight = this.highLight(this.colorsecondary);
        //     this.highdark = this.highLight(this.colorsecondary);
    
        //     // below colors for diffused transparent effects for cards,badges etc
        //     this.diffuselight = this.diffuseLight(this.lightermain, 0.3);
        //     this.diffusecolor = this.diffuseLight(this.colortertiary, 0.3);
        //     this.diffusedark = this.diffuseDark(this.darkermain, 0.3);
        //     this.diffusecolorselected = this.diffuseLight(this.colortertiary, 0.6);
        //     this.diffusedarkselected = this.diffuseDark(this.darkermain, 0.6);
        //     this.diffuselightselected = this.diffuseLight(this.lightermain, 0.6);
    
        //     // below colors for text colors
        //     this.colorlight = this.hslColorLight(this.colorprimary);
        //     this.colordark = this.hslColorDark(this.colorprimary);
    
        //     this.invertPrime = this.invertHsl(this.colorprimary);
        //     this.invertSecond = this.invertHsl(this.colorsecondary);
        //     this.invertTri = this.invertHsl(this.colortertiary);
    
        //     this.dtextprimary = this.dynamicText(this.colorprimary);
        //     this.dtextsecond = this.dynamicText(this.colorsecondary);
        //     this.dtexttri = this.dynamicText(this.colortertiary);
    
        //     // below colors for svg background
        //     this.colorback = this.backLight(this.colorsecondary);
        //     this.colorbackdark = this.backDark(this.colorsecondary);
    
        //     // below colors for shadows highlighted
        //     this.shadowhighlight = this.hslMakerShadow(
        //       this.hslShadowColorLight(this.highLightShadow(this.colorsecondary))
        //     );
        //     this.shadowhighdark = this.hslMakerShadow(
        //       this.hslShadowColorDark(this.highLightShadow(this.colorsecondary))
        //     );
    
        //     // below colors for faded colors
    
        //     // below colors for main 3 this.colors.
    
      
        //     this.p3 = this.hslopacity(this.colorprimary, 0.5);
        //     this.s3 = this.hslopacity(this.colorsecondary, 0.5);
        //     this.t3 = this.hslopacity(this.colortertiary, 0.5);
    
        //     this.p4 = this.hslopacity(this.colorprimary, 0.8);
        //     this.s4 = this.hslopacity(this.colorsecondary, 0.8);
        //     this.t4 = this.hslopacity(this.colortertiary, 0.8);
        //     // console.log(this.colorsecondarymain);
    
        //     htmlEl.style.setProperty("--p3", this.p3);
        //     htmlEl.style.setProperty("--s3", this.s3);
        //     htmlEl.style.setProperty("--t3", this.t3);
    
        //     htmlEl.style.setProperty("--p4", this.p4);
        //     htmlEl.style.setProperty("--s4", this.s4);
        //     htmlEl.style.setProperty("--t4", this.t4);
    
        //     htmlEl.style.setProperty("--low-nutri", this.lowNutrition);
        //     htmlEl.style.setProperty("--avg-nutri", this.avgNutrition);
        //     htmlEl.style.setProperty("--high-nutri", this.highNutrition);
    
        //   //dm affected colors
    
        //     htmlEl.style.setProperty("--ion-color-primary", this.colorprimarymain);
        //     htmlEl.style.setProperty("--ion-color-secondary", this.colorsecondarymain);
        //     htmlEl.style.setProperty("--ion-color-tertiary", this.colortertiarymain);
  
        // htmlEl.style.setProperty("--ion-light-primary", this.colorprimarylighter);
        //     htmlEl.style.setProperty("--ion-light-secondary", this.colorsecondarylighter);
        //     htmlEl.style.setProperty("--ion-light-tertiary", this.colortertiarylighter);
  
        // htmlEl.style.setProperty("--ion-dark-primary", this.colorprimarydeeper);
        //     htmlEl.style.setProperty("--ion-dark-secondary", this.colorsecondarydeeper);
        //     htmlEl.style.setProperty("--ion-dark-tertiary", this.colortertiarydeeper);
    
        //     htmlEl.style.setProperty("--p2", this.p2);
        //     htmlEl.style.setProperty("--s2", this.s2);
        //     htmlEl.style.setProperty("--t2", this.t2);
    
        //     htmlEl.style.setProperty("--tprimary", this.invertPrime);
        //     htmlEl.style.setProperty("--tsecondary", this.invertSecond);
        //     htmlEl.style.setProperty("--ttertiary", this.invertTri);
    
        //     htmlEl.style.setProperty("--ion-text-primary", this.dtextprimary);
        //     htmlEl.style.setProperty("--ion-text-secondary", this.dtextsecond);
        //     htmlEl.style.setProperty("--ion-text-tertiary", this.dtexttri);
    
        //     htmlEl.style.setProperty("--shadow-light", this.shadowlight); //grays only for base shadows
        //     htmlEl.style.setProperty("--shadow-color-light", this.shadowcolorlight); //colored shadows will be based on primary color
        //     htmlEl.style.setProperty("--bg-light", this.bglight); // background color will be based on primary color
        //     htmlEl.style.setProperty("--bg-dark", this.bgdark);
        //     htmlEl.style.setProperty("--highlight", this.highlight);
        //     htmlEl.style.setProperty("--highdark", this.highdark); //highlights colors - based on secondary color
        //     htmlEl.style.setProperty("--shadowhighdark", this.shadowhighdark);
        //     htmlEl.style.setProperty("--shadowhighlight", this.shadowhighlight); //based on the highlight color
        //     htmlEl.style.setProperty("--diffuse-light", this.diffuselight);
        //     htmlEl.style.setProperty("--diffuse-dark", this.diffusedark);
        //     htmlEl.style.setProperty("--diffuse-color", this.diffusecolor);
        //     htmlEl.style.setProperty(
        //       "--diffuse-color-selected",
        //       this.diffusecolorselected
        //     );
        //     htmlEl.style.setProperty(
        //       "--diffuse-light-selected",
        //       this.diffuselightselected
        //     );
        //     htmlEl.style.setProperty(
        //       "--diffuse-dark-selected",
        //       this.diffusedarkselected
        //     );
        //     htmlEl.style.setProperty("--ion-light", this.colorlight);
        //     htmlEl.style.setProperty("--ion-dark", this.colordark);
        //     htmlEl.style.setProperty("--colorback", this.colorback);
        //     htmlEl.style.setProperty("--ion-color-light", this.white);
        //     htmlEl.style.setProperty("--ion-color-dark", this.dark);
        //     htmlEl.style.setProperty("--light", this.colorlight);
        //     htmlEl.style.setProperty("--dark", this.colordark);
        //     htmlEl.style.setProperty(
        //       "--diffuse-selected",
        //       this.diffusedarkselected
        //     );
        //     htmlEl.style.setProperty("--diffuse", this.diffusedark);
    
        //     htmlEl.style.setProperty("--lightgrey", this.lightgrey);
        //     htmlEl.style.setProperty("--darkgrey", this.darkgrey);
        //     htmlEl.style.setProperty("--darker", this.darker);
        //     htmlEl.style.setProperty("--grey", this.grey);
        //     htmlEl.style.setProperty("--greyhalf", this.greyhalf);
        //     htmlEl.style.setProperty("--greymore", this.greymore);
        //     htmlEl.style.setProperty("--greyless", this.greyless);
    
          
        }, 200);
      });
    }, 500);	
  }
getBackgroundImage() {
    this.apiService
        .get(endpoints.banners + '?category=banner')
        .subscribe(
            res => {
                console.log(res);
                if (res.success) {
                    // Filter banners with category 'appBg'
                    const appBgBanners = res.data?.banners
                        .filter(banner => banner.category === 'appBg')
                        .map(banner => banner.attachment); // Extract attachment URLs
                    console.log(appBgBanners)
                    if (appBgBanners && appBgBanners.length > 0) {
                        this.banners = appBgBanners;
                        this.startBannerRotation();
                    } else {
                        console.log('No banners found with category "appBg".');
                    }
                }
            },
            err => {
                console.log(err);
            }
        );
}

startBannerRotation() {
    if (this.bannerSwitchInterval) {
        clearInterval(this.bannerSwitchInterval); // Clear any existing interval
    }

    // Set the initial background
    this.setBodyBackgroundImage(this.banners[this.currentBannerIndex]);

    // Rotate banners every 5 seconds
    this.bannerSwitchInterval = setInterval(() => {
        this.currentBannerIndex = (this.currentBannerIndex + 1) % this.banners.length;
        this.setBodyBackgroundImage(this.banners[this.currentBannerIndex]);
    }, 50000); // Change 5000 to desired interval in milliseconds
}

setBodyBackgroundImage(url: string) {
    // Dynamically set the background image on the body
    document.body.style.backgroundImage = `url(${url})`;
}

ngOnDestroy() {
    // Clear the interval when the component is destroyed
    if (this.bannerSwitchInterval) {
        clearInterval(this.bannerSwitchInterval);
    }
}
    checkLatestVersion = async (appData: any) => {
        const versionNumbner = await this.appVersion.getVersionNumber();
        if (this.platform.is("android")) {
            console.log(appData);
            const androidResponse = appData.android;
            this.androidURL = appData.application_url;
            this.serverVersion = androidResponse.latest_version.split('.');
            this.splittedVersion = versionNumbner.split('.');
            if (androidResponse.enabled) {
                this.backButton = false;
                this.appUpdate(androidResponse.alerts.maintenance.title, androidResponse.alerts.maintenance.description);
            } else if (this.serverVersion[0] > this.splittedVersion[0]) {
                //major changes
                this.backButton = false;
                this.appUpdate(androidResponse.alerts.mandatory.title, androidResponse.alerts.mandatory.description, androidResponse.alerts.mandatory.button_text);
                this.events.publish('app:update', { user: null, time: new Date() });
            } else if (this.serverVersion[1] > this.splittedVersion[1]) {
                //minor changes
                this.appUpdate(androidResponse.alerts.minor.title, androidResponse.alerts.minor.description, androidResponse.alerts.minor.button_text, true);
            } else if (this.serverVersion[2] > this.splittedVersion[2]) {
                //optional changes
                this.appUpdate(androidResponse.alerts.optional.title, androidResponse.alerts.optional.description, androidResponse.alerts.optional.button_text, true);
            }

        } else if (this.platform.is("ios")) {
            console.log(appData);
            const iosResponse = appData.ios;
            //alert(versionNumbner);
            //alert(iosResponse.latest_version);
            this.iosURL = iosResponse.url;
            this.serverVersion = iosResponse.latest_version.split('.');
            this.splittedVersion = versionNumbner.split('.');
            if (iosResponse.enabled) {
                this.backButton = false;
                this.appUpdate(iosResponse.alerts.maintenance.title, iosResponse.alerts.maintenance.description);
            } else if (this.serverVersion[0] > this.splittedVersion[0]) {
                //major changes
                this.backButton = false;
                this.appUpdate(iosResponse.alerts.mandatory.title, iosResponse.alerts.mandatory.description, iosResponse.alerts.mandatory.button_text);
                this.events.publish('app:update', { user: null, time: new Date() });
            } else if (this.serverVersion[1] > this.splittedVersion[1]) {
                //minor changes
                this.appUpdate(iosResponse.alerts.minor.title, iosResponse.alerts.minor.description, iosResponse.alerts.minor.button_text, true);
            } else if (this.serverVersion[2] > this.splittedVersion[2]) {
                //optional changes
                this.appUpdate(iosResponse.alerts.optional.title, iosResponse.alerts.optional.description, iosResponse.alerts.optional.button_text, true);
            }
        }
    }
    openAppstoreEntry = async () => {
        if (this.platform.is("android")) {
            this.inAppBrowser.create(this.androidURL, '_blank');
            // NativeMarket.openStoreListing({
            //     appId: await this.appVersion.getPackageName().then(packageName => {return packageName;})
            // });
        } else if (this.platform.is("ios")) {
            this.inAppBrowser.create(this.iosURL, '_blank');
        }
    }
    appUpdate = async (header, message, buttonText = '', allowcloss = false) => {
        const buttons = [];
        if (buttonText != '') {
            buttons.push({
                text: buttonText,
                handler: () => {
                    this.openAppstoreEntry();
                }
            });
        }
        if (allowcloss) {
            buttons.push({
                text: 'Close',
                role: 'Cancel'
            });
        }
        await this.alertCtrl.create({
            header,
            message,
            buttons,
            mode: 'ios',
            backdropDismiss: allowcloss
        }).then(alertElem => alertElem.present());

    }
    appUser = (currentUser: any) => {
        //console.log(currentUser);
        if (currentUser && currentUser != null &&
            window.localStorage.getItem('auth-token') != 'null' &&
            window.localStorage.getItem('auth-token') != null) {
        } else {
            //window.localStorage.setItem('auth-token', null);
        }
    }
    backButtonEvent = () => {
        this.platform.backButton
            .subscribeWithPriority(10, async () => {
                try { const element = await this.alertCtrl.getTop(); if (element) { element.dismiss(); return; } } catch (error) { console.log(error); }
                try { const element = await this.modalCtrl.getTop(); if (element) { element.dismiss(); return; } } catch (error) { console.log(error); }
                this.routerOutlets.forEach(async (outlet: IonRouterOutlet) => {
                    //alert(this.router.url);
                    if (outlet && outlet.canGoBack()) {
                        outlet.pop();
                    } else if (this.router.url === '/'
                        || this.router.url === '/signin'
                        //|| this.router.url === '/home' || this.router.url === '/salon'
                        || this.router.url === '/onboarding'
                    ) {
                        if (new Date().getTime() - this.lastTimeBackPress < this.timePeriodToExit) {
                            await this.showConfirm();
                        } else {
                            await this.toastCtrl.create({
                                message: this.translate.instant('press_back_again_to_exit_app'),
                                duration: 4000,
                                position: 'top',
                                color: 'dark'
                            }).then((toastElem) => toastElem.present());

                        }
                        this.lastTimeBackPress = new Date().getTime();
                    }
                    // else if(this.router.url === '/subscription-list?historyRoute=login&landingPage=signup')
                    // {
                    //     alert('MD');
                    // }
                });
            });
    }
    checkNetworkConnection = () => {
        this.network.onDisconnect()
            .subscribe(() => {
                this.connectedToInternet = false;
                this.translate.get(["Please Connect to the Internet!", "Disconnected"])
                    .subscribe(async (res) => {
                        let alertMsg = await this.alertCtrl.create({
                            header: this.translate.instant('no_internet'),
                            message: this.translate.instant('please_connect_to_the_internet'),
                            mode: 'ios',
                            buttons: [{ text: this.translate.instant('ok'), handler: () => { navigator['app'].exitApp(); } }]
                        });
                        alertMsg.present();
                    }
                    );
            }
            );
        this.network.onConnect()
            .subscribe(() => {
                if (!this.connectedToInternet) {
                    window.location.reload();
                    this.translate.get(["Network connected Reloading Data", "Connected"])
                        .subscribe(async (res) => {
                            let alertMsg = await this.alertCtrl.create({
                                header: this.translate.instant('network_found'),
                                message: this.translate.instant('network_connected_reloading_data'),
                                mode: 'ios',
                                buttons: [{ text: this.translate.instant('ok') }]
                            });
                            alertMsg.present();
                        }
                        );
                }
            }
            );
    }
    showConfirm = async () => {
        const alert = await this.alertCtrl.create({
            header: this.translate.instant('confirm'),
            message: this.translate.instant('are_you_sure_you_want_to_exit_the_app'),
            buttons: [
                {
                    text: this.translate.instant('cancel'),
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: (blah) => { }
                },
                {
                    text: this.translate.instant('close_app'),
                    handler: () => {
                        navigator['app'].exitApp();
                    }
                }],
            //enterAnimation: customAlertEnter
        });
        await alert.present();
    }

 hexToHsl(hex) {
    hex = hex.replace(/^#/, '');

    let r = 0,
        g = 0,
        b = 0;

    // Check for shorthand hex (e.g., #abc) and expand it
    if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
        // Full hex (e.g., #aabbcc)
        r = parseInt(hex.slice(0, 2), 16);
        g = parseInt(hex.slice(2, 4), 16);
        b = parseInt(hex.slice(4, 6), 16);
    } else {
        throw new Error('Invalid HEX color format');
    }

    // Convert RGB values to a range of 0 to 1
    r /= 255;
    g /= 255;
    b /= 255;

    // Find the max and min values of RGB
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;

    // Calculate Lightness
    let l = (max + min) / 2;

    let h = 0,
        s = 0;

    if (delta !== 0) {
        // Calculate Hue and Saturation only if there's no gray (delta = 0)
        // Saturation
        s = delta / (1 - Math.abs(2 * l - 1));

        // Hue
        if (max === r) {
            h = ((g - b) / delta + (g < b ? 6 : 0)) % 6;
        } else if (max === g) {
            h = (b - r) / delta + 2;
        } else if (max === b) {
            h = (r - g) / delta + 4;
        }

        h *= 60; // Convert to degrees
    }

    // Convert to percentages
    h = Math.round(h);
    s = Math.round(s * 100);
    l = Math.round(l * 100);

    return {
        h,
        s,
        l
    };
}
 invertHsl(hsl) {
    let h = (hsl.h + 180) % 360;
    let l = hsl.l < 50 ? hsl.l + 30 : hsl.l - 30;
    return {
        h: h,
        s: hsl.s,
        l: l,
        alpha: 1
    };
}
 dynamicText(hsl) {
    let l = hsl.l <= 51 ? 100 : 0;
    console.log(l, hsl.l, 'l and hsl.l');
    const safeHSL = {
        h: 0,
        s: 0,
        l: l,
        alpha: hsl?.alpha ?? 1 // Use hsl.alpha if defined, otherwise default to 1
    };
    return safeHSL;
}

 setColorVariables(htmlEl, prefix, baseHSL, shades) {
    Object.keys(shades).forEach((shade) => {
        // Get the modified HSL values
        const modifiedHSL = shades[shade]({
            ...baseHSL
        });

        // Set the traditional variable with opacity included
        htmlEl.style.setProperty(
            `--ion-${shade}-${prefix}`,
            this.finalHSL(modifiedHSL)
        );

        // Set a new color-only variable without opacity
        htmlEl.style.setProperty(
            `--drop-${shade}-${prefix}`,
            `${modifiedHSL.h}deg ${modifiedHSL.s}% ${modifiedHSL.l}%`
        );
    });
}

 generateShadowString(shadowConfig, hsl) {
    return shadowConfig.map(shadow => {
        let spreadStr = shadow.spread ? ` ${shadow.spread}px` : '';
        let insetStr = shadow.inset ? ' inset' : '';
        return `${shadow.x}px ${shadow.y}px ${shadow.blur}px${spreadStr} hsl(${hsl.h}deg ${hsl.s}% ${hsl.l}% / ${shadow.opacity})${insetStr}`;
    }).join(', ');
}

 setShadowVariables(htmlEl, prefix, baseHSL) {
    // Create light and dark versions of the base color for shadows
    let shadowLight = this.hslModify(baseHSL, {
        l: {
            fixed: 25
        },
        s: {
            percent: -10
        }
    });

    let shadowDark = this.hslModify(baseHSL, {
        l: {
            fixed: 10
        },
        s: {
            percent: 60
        }
    });

    let shadowColor = this.hslModify(baseHSL, {
        opacity: 1
    });
    let shadowColor2 = this.hslModify(baseHSL, {
        opacity: 0.5
    });
    let shadowMain = this.hslModify(baseHSL, {
        l: {
            fixed: 5
        },
        s: {
            fixed: 0
        }
    });
        let shadowGrey = this.hslModify(baseHSL, {
          l: {l: Math.min(Math.max(baseHSL.l * 0.50, 10),40)},
          s: {s: Math.min(Math.max(baseHSL.s * .60, 40), 100)},
          h: {h: baseHSL.h < 180 ? (baseHSL.h + 60) % 360 : (baseHSL.h - 60 + 360) % 360},
          opacity: 1
    });

    // Set base shadow variables
    htmlEl.style.setProperty(`--shadow-light`, `${shadowLight.h}deg ${shadowLight.s}% ${shadowLight.l}%`);
    htmlEl.style.setProperty(`--shadow-dark`, `${shadowDark.h}deg ${shadowDark.s}% ${shadowDark.l}%`);

    // Generate all shadow variations
    Object.entries(this.shadowConfigs).forEach(([key, config]) => {
        htmlEl.style.setProperty(
            `--shadow-${key}`,
            this.generateShadowString(config, shadowMain)
        );

        // Also create a dark version
        htmlEl.style.setProperty(
            `--shadow-${key}-dark`,
            this.generateShadowString(config, shadowDark)
        );
               htmlEl.style.setProperty(
            `--shadow-${key}-grey`,
            this.generateShadowString(config, shadowGrey)
        );
        htmlEl.style.setProperty(
            `--shadow-${key}-light`,
            this.generateShadowString(config, shadowLight)
        );
        htmlEl.style.setProperty(
            `--shadow-${key}-color`,
            this.generateShadowString(config, shadowColor)
        );
    });
}

 theColorUpdate(primary, secondary, tertiary) {
    const htmlEl = document.documentElement; // Get the root HTML element
    if (!htmlEl) return;

    const primaryHSL = this.hexToHsl(primary);
    const secondaryHSL = this.hexToHsl(secondary);
    const tertiaryHSL = this.hexToHsl(tertiary);
    const greyHSL = this.hexToHsl('#c1c1c1');
    const dangerHSL = this.hexToHsl('#d32f2f');      // Soft red (danger)
    const successHSL = this.hexToHsl('#388e3c');     // Balanced green (success)
    const warningHSL = this.hexToHsl('#f57c00');     // Slightly muted orange (warning)
    const infoHSL = this.hexToHsl('#1976d2');        // Standard info blue
    const maleHSL = this.hexToHsl('#1565c0');        // Deep, bold blue
    const femaleHSL = this.hexToHsl('#8e24aa');      // Elegant purple
    const healthHSL = this.hexToHsl('#2e7d32');      // Strong green (wellness)
    const unhealthHSL = this.hexToHsl('#c62828');    // Deep red (opposite to health)
    let shades = {
      
        color: (hsl) => this.hslModify(hsl, {opacity: 1
          }),

        black: (hsl) => this.hslModify(hsl, {
          l: {fixed: 2},
          opacity: 1
          }),
        white: (hsl) => this.hslModify(hsl, {
          l: {fixed: 100},
          opacity: 1
          }),

        pass: (hsl) => this.hslModify(hsl, {
          opacity: 0.05
          }),
        ultra: (hsl) => this.hslModify(hsl, {
          opacity: 0.15
          }),
        fade: (hsl) => this.hslModify(hsl, {
          opacity: 0.25
          }),
        less: (hsl) => this.hslModify(hsl, {
          opacity: 0.35
          }),
        clear: (hsl) => this.hslModify(hsl, {
          opacity: 0.5
          }),
        half: (hsl) => this.hslModify(hsl, {
          opacity: 0.75
          }),
        more: (hsl) => this.hslModify(hsl, {
          opacity: 0.85
          }),

        shadeLight: (hsl) => this.hslModify(hsl, {
          l: {l: Math.min(Math.max(hsl.l * 1.10, 10),90)},
          s: {s: Math.min(Math.max(hsl.s * 0.90, 10), 100)},
          opacity: 1
          }),

        shadeDark: (hsl) => this.hslModify(hsl, {
          l: {l: Math.min(Math.max(hsl.l * 0.90, 10),90)},
          s: {s: Math.min(Math.max(hsl.s * 1.10, 10), 100)},
          opacity: 1
          }),        
          
        light: (hsl) => this.hslModify(hsl, {
          l: {s: Math.min(Math.max(hsl.l * 2.30, 10), 70)},
          s: {s: Math.min(Math.max(hsl.s * 0.30, 10), 100)},
          opacity: 1
          }),

        dark: (hsl) => this.hslModify(hsl, {
          l: {s: Math.min(Math.max(hsl.l * 0.30, 10), 30)},
          s: {s: Math.min(Math.max(hsl.s * 1.30, 10), 100)},
          opacity: 1
          }),
          
        lighter: (hsl) => this.hslModify(hsl, {
          l: {s: Math.min(Math.max(hsl.l * 2.30, 10), 80)},
          s: {s: Math.min(Math.max(hsl.s * 0.50, 10), 100)},
          opacity: 1
          }),

        darker: (hsl) => this.hslModify(hsl, {
          l: { l: 5 },
          s: {s: Math.min(Math.max(hsl.s * 1.50, 10), 100)},
          opacity: 1
          }),

        bright: (hsl) => this.hslModify(hsl, {
          l: {l: Math.min(Math.max(hsl.s * 1.60, 10), 90)},
          s: {s: Math.min(Math.max(hsl.s * 1.20, 10), 90)},
          opacity: 1
        }),
        washed: (hsl) => this.hslModify(hsl, {
          s: {s: Math.min(Math.max(hsl.s * 0.50, 10), 50)},
          l: {l: 92},
          opacity: 1
        }),
        bareLight: (hsl) => this.hslModify(hsl, {
          s: {s: Math.min(Math.max(hsl.s * 0.50, 10), 70)},
          l: {l: 90},
          opacity: 1
        }),
        bareDark: (hsl) => this.hslModify(hsl, {
          s: {s: Math.min(Math.max(hsl.s * 0.50, 10), 70)},
          l: {l: 10},
          opacity: 1
        }),
        highlight: (hsl) => this.hslModify(hsl, {
          l: {l: hsl.l > 60 ? Math.min(Math.max(hsl.l - 10, 20), 80) : Math.min(Math.max(hsl.l + 15, 10), 90)},
          h: {h: (hsl.h + 5) % 360},
          s: {s: Math.min(Math.max(hsl.s * 1.25, 10), 90)},
          opacity: 1
        }),
        dull: (hsl) => this.hslModify(hsl, {
          l: {l: Math.min(Math.max(hsl.s * 1, 10), 45)},
          s: {s: Math.min(Math.max(hsl.s * 0.95, 30), 80)},
          opacity: 1
        }),
        cool: (hsl) => this.hslModify(hsl, {
          s: {s: Math.min(hsl.s - 10, 70)},
          h: {h: (hsl.h + 15) % 360},
          opacity: 1
        }),
        warm: (hsl) => this.hslModify(hsl, {
          s: {s: Math.min(hsl.s + 10, 70)},
          h: {h: (hsl.h - 15 + 360) % 360},
           opacity: 1
        }),
        diffuseLight: (hsl) => this.hslModify(hsl, {
          l: {l: 95},
          s: {s: Math.min(Math.max(hsl.s * 0.75, 30), 80)},
          opacity: 0.9
        }),
        diffuseDark: (hsl) => this.hslModify(hsl, {
          l: {l: 3},
          opacity: 0.7
        }),
      

        text: (hsl) => this.dynamicText(hsl),
        invert: (hsl) => this.invertHsl(hsl),
    }

    this.setColorVariables(htmlEl, 'primary', {
        ...primaryHSL
    }, shades);
    this.setColorVariables(htmlEl, 'secondary', {
        ...secondaryHSL
    }, shades);
    this.setColorVariables(htmlEl, 'tertiary', {
        ...tertiaryHSL
    }, shades);
    this.setColorVariables(htmlEl, 'grey', {
        ...greyHSL
    }, shades);
    this.setColorVariables(htmlEl, 'danger', {
        ...dangerHSL
    }, shades);
    this.setColorVariables(htmlEl, 'success', {
        ...successHSL
    }, shades);
    this.setColorVariables(htmlEl, 'warning', {
        ...warningHSL
    }, shades);
    this.setColorVariables(htmlEl, 'info', {
        ...infoHSL
    }, shades);
    this.setColorVariables(htmlEl, 'male', {
        ...maleHSL
    }, shades);
    this.setColorVariables(htmlEl, 'female', {
        ...femaleHSL
    }, shades);
    this.setColorVariables(htmlEl, 'health', {
        ...healthHSL
    }, shades);
    this.setColorVariables(htmlEl, 'unhealth', {
        ...unhealthHSL
    }, shades);

    this.setShadowVariables(htmlEl, 'primary', primaryHSL);
}
 hslModify(
  hsl: HSLColor,
  options: HSLModifyOptions = {}
): HSLColor {
  const { h = {}, s = {}, l = {}, opacity = 1 } = options;

  const modifiedHsl: HSLColor = { ...hsl };

  if (h.fixed !== undefined) modifiedHsl.h = h.fixed;
  if (h.percent !== undefined) modifiedHsl.h *= (1 + h.percent / 100);
  if (h.adjust !== undefined) modifiedHsl.h += h.adjust;

  if (s.fixed !== undefined) modifiedHsl.s = s.fixed;
  if (s.percent !== undefined) modifiedHsl.s *= (1 + s.percent / 100);
  if (s.adjust !== undefined) modifiedHsl.s += s.adjust;

  if (l.fixed !== undefined) modifiedHsl.l = l.fixed;
  if (l.percent !== undefined) modifiedHsl.l *= (1 + l.percent / 100);
  if (l.adjust !== undefined) modifiedHsl.l += l.adjust;

  if (l.l !== undefined) modifiedHsl.l = l.l;
  if (h.l !== undefined) modifiedHsl.l = h.l;
  if (s.l !== undefined) modifiedHsl.l = s.l;
  
  if (l.h !== undefined) modifiedHsl.h = l.h;
  if (h.h !== undefined) modifiedHsl.h = h.h;
  if (s.h !== undefined) modifiedHsl.h = s.h;

  if (l.s !== undefined) modifiedHsl.s = l.s;
  if (h.s !== undefined) modifiedHsl.s = h.s;
  if (s.s !== undefined) modifiedHsl.s = s.s;

  modifiedHsl.opacity = opacity;

  return modifiedHsl;
}
 finalHSL(hsl) {
    const safeHSL = {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        opacity: hsl?.opacity ?? 1 // Use 1 if alpha is undefined or null
    };

    return `hsl(${safeHSL.h}deg ${safeHSL.s}% ${safeHSL.l}% / ${safeHSL.opacity})`;
}


}

// // Color Functions

// // l: {l: Math.min(Math.max(hsl.l * 1.15, 10),90)},

// // l: {l: Math.min(Math.max(hsl.l + 20, 0),100)},

// // l: {l: Math.min(Math.max((hsl.l + 10) * 0.8, 5),95)},

// // l: {l: hsl.l > 60 ? Math.min(Math.max(hsl.l - 10, 20), 80) : Math.min(Math.max(hsl.l + 15, 10), 90)},


// // h: {h: (hsl.h * 1.2) % 360}

// // h: {h: (hsl.h + 40) % 360}

// // h: {h: (hsl.h - 40 + 360) % 360}

// // h: {h: ((hsl.h + 30) * 0.85) % 360}

// // h: {h: hsl.h < 180 ? (hsl.h + 60) % 360 : (hsl.h - 60 + 360) % 360}

// // h: {h: (hsl.h + 180) % 360}


// // s: {s: Math.min(Math.max(hsl.s * 1.25, 10), 100)},

// // s: {s: Math.min(Math.max(hsl.s - 20, 0), 100)}

// // s: {s: Math.min(Math.max((hsl.s + 15) * 0.8, 5), 90)}

// // s: {s: hsl.s > 60 ? Math.max(hsl.s - 25, 10) : Math.min(hsl.s + 30, 90)}